import { I18n } from "@assets/strings";
import React, { MouseEventHandler } from "react";
import styled, { css } from "styled-components";
import { DeleteIconBig } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface DeleteButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	onClick: MouseEventHandler;
	text?: string;
	disabled?: boolean;
}
export const DeleteButton: React.FC<DeleteButtonProps> = ({ text, disabled, ...htmlProps }) => {
	return (
		<Container {...htmlProps} disabled={disabled}>
			<DeleteIconBig />
			<div>{text ?? I18n.t("delete")}</div>
		</Container>
	);
};

const Container = styled.button<{ disabled?: boolean }>`
	cursor: pointer;
	border: none;
	outline: none;
	${({ theme }) => theme.textStyles.label};
	background-color: ${({ theme }) => theme.colors.lightergray};
	border-radius: 7px;
	padding: 4px 6px;
	${row(4, "flex-start", "center")}
	> div {
		${({ theme }) => theme.textStyles.secondaryFontFamily};
		font-weight: 600;
	}
	> svg {
		width: 13px;
		height: 13px;
		path {
			fill: ${({ theme }) => theme.colors.textSecondary};
		}
	}
	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.4;
		`}
`;
